import { ModalNew as Modal } from "components/Modal/ModalNew";
import { KeyPersonnel } from "pages/RFQ/RFQ/CreateRFQ/PreviewRFQ/Questionnaire/_components/KeyPersonnel";
import { ProjectExperienceCard } from "pages/RFQ/RFQ/CreateRFQ/PreviewRFQ/Questionnaire/_components/ProjectExperience";

const getSelectedModalByType = (type, value, companyId) => {
	if (type === "key_personnel") {
		return {
			buttonText: "Selected Key Personnels",
			modalTitle: "Selected Key Personnels",
			modalContent: (
				<div className="grid grid-cols-2 gap-6 lg:grid-cols-3">
					{value.map((person) => (
						<KeyPersonnel
							key={person.id}
							values={person}
							companyId={companyId}
							isPreview
							supplierSmartField
							className="min-w-[unset]"
						/>
					))}
				</div>
			),
		};
	}
	return {
		buttonText: "Selected Projects",
		modalTitle: "Selected Project Experiences",
		modalContent: (
			<div className="grid grid-cols-2 gap-6 lg:grid-cols-3">
				{value.map((project) => (
					<ProjectExperienceCard
						key={project.id}
						values={project}
						companyId={companyId}
						isPreview
						supplierSmartField
						className="min-w-[unset]"
					/>
				))}
			</div>
		),
	};
};

const SelectedValueModal = ({
	isOpen,
	onClose,
	type,
	questionId,
	companyId,
	selectedData,
}) => {
	const modalProps = getSelectedModalByType(
		type,
		selectedData || [],
		companyId
	);

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			headerContent={modalProps.modalTitle}
		>
			{modalProps.modalContent}
		</Modal>
	);
};

export default SelectedValueModal;
